import { plaintextValidator, dropdownValidator } from '../fields';
import { stringMandateConstraints } from '../utils';
import ruleBuilder from '../utils/RuleBuilder';

const config = { mandatory: true };

export const conditionalPricingConstraints = {
  name: plaintextValidator(config),
  items: {
    array: {
      serviceItem: dropdownValidator({ mandatory: true }),
      businessHoursPrice: plaintextValidator(config)
      // afterHoursPrice: plaintextValidator(config)
    }
  },
  ...ruleBuilder('ruleCondition.operands')
};
